'use client';

import { useState } from 'react';
import Accordion, { IAccordion } from './Accordion';

export default function AwardsSection({ accordions }: { accordions: IAccordion[] }) {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleAccordion = (index: number) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <div>
            {accordions.map(({ title, content }, index) => (
                <Accordion
                    title={title}
                    content={content}
                    index={index}
                    key={index}
                    isOpen={openIndex === index}
                    toggleAccordion={toggleAccordion}
                />
            ))}
        </div>
    );
}
